import { Type } from 'class-transformer';
import {
	IsArray,
	IsEnum,
	IsInt,
	IsOptional,
	IsString,
	ValidateNested,
} from 'class-validator';
import { Priority } from '../../enums';
import {
	ClientIssueInterface,
	IssueInterface,
	IssueStatus,
	IssueType,
	VendorIssueInterface,
} from '../database';

class IssueDto implements Partial<IssueInterface> {
	@IsOptional()
	@IsString()
	public name?: string;

	@IsOptional()
	@IsString()
	public description?: string | null;

	@IsOptional()
	@IsEnum(IssueStatus)
	public status?: IssueStatus;

	@IsOptional()
	@IsEnum(IssueType)
	public type?: IssueType | null;

	@IsOptional()
	@IsEnum(Priority)
	public priority?: Priority;

	@IsOptional()
	@IsInt()
	@Type(() => Number)
	public assigneeUserId?: number | null;

	public id?: number;
	public statusUpdatedDatetime?: Date | null;
}

export class SaveIssueRequestDto {
	@ValidateNested()
	@Type(() => IssueDto)
	public issue!: IssueDto;

	@IsOptional()
	@IsArray()
	@IsInt({ each: true })
	@Type(() => Number)
	public clientIds?: Array<ClientIssueInterface['fk_client__id']>;

	@IsOptional()
	@IsArray()
	@IsInt({ each: true })
	@Type(() => Number)
	public vendorIds?: Array<VendorIssueInterface['fk_vendor__id']>;
}
